export function getSaleCreditAccountPayment(sale: Sale): number {
  let paymentAmount = 0;

  if (sale.SalePayments) {
    const salePayments = sale.SalePayments.SalePayment;

    if (Array.isArray(salePayments)) {
      const creditAccountPayments = salePayments.filter(
        (payment) => payment.PaymentType.paymentTypeID === '4'
      );

      if (creditAccountPayments.length) {
        paymentAmount = creditAccountPayments.reduce((total, payment) => {
          const amount = Math.abs(Number(payment.amount));
          return isNaN(amount) ? total : total + amount;
        }, 0);
      }
    } else if (salePayments.PaymentType.paymentTypeID === '4') {
      const amount = Math.abs(Number(salePayments.amount));
      paymentAmount = isNaN(amount) ? 0 : amount;
    }
  }

  return paymentAmount;
}
